// extracted by mini-css-extract-plugin
module.exports = {"howTo":"HowTo_howTo__1HEvU","howToItem":"HowTo_howToItem__2DCwZ","desc":"HowTo_desc__gc5KZ","image":"HowTo_image__2ECmc"};